<template>
  <DashboardCard ref="dashboardCard" @controlsOpen="
    track(`configurações da tela_links prontos ou personalizados_
    ${usePageAdvertiser ? pageAdvertiser.name : 'Dashboard'}`)">
    <img src="@/assets/images/links.svg" alt="Link" slot="icon" class="card-icon">
    <span slot="title">Links prontos ou personalizados</span>

    <div slot="controls">
      <div>
        <h4 class="d-flex my-3">
          <img src="@/assets/images/icon_tools.svg" class="card-icon mr-1">
          <p class="control-label text-warning mb-0">Configurar identificador</p>
        </h4>
        <LabelSelector v-model="label"/>
      </div>
    </div>

    <LinkForm

      :presetAdvertiser="presetAdvertiser"
      :usePageAdvertiser="usePageAdvertiser"
      :presetLabel="label[0]"
      :customLink="customLink"
      @labelUpdated="newLabel => updateLabel(newLabel)"
      @showAllRules="$emit('showAllRules')"/>
  </DashboardCard>
</template>

<script>
import { mapGetters } from 'vuex';
import LinkForm from './LinkForm';
import LabelSelector from './LabelSelector';
import DashboardCard from './DashboardCard';

export default {
  name: 'LinkFormCard',
  components: {
    LinkForm,
    LabelSelector,
    DashboardCard,
  },
  props: {
    presetAdvertiser: {
      type: Object,
      default: undefined,
    },
    usePageAdvertiser: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      customLink: false,
      label: [],
      options: [
        {
          name: 'Link pronto',
          value: false,
        },
        {
          name: 'Link personalizado',
          value: true,
        },
      ],
    };
  },
  methods: {
    setCustomLink(toggle) {
      this.customLink = toggle;
      window.localStorage.setItem('aff-dashboard__custom-link', toggle);
    },
    updateLabel(label) {
      this.label = [label];
    },
  },
  computed: {
    ...mapGetters([
      'pageAdvertiser',
    ]),
  },
  async created() {
    this.customLink = window.localStorage.getItem('aff-dashboard__custom-link') === 'true';
  },
};
</script>

<style lang="scss" scoped>
.control-label {
  @include text-size-regular();
}

/deep/ {
  .card__controls__panel {
    @media screen and (min-width: $lg){
      width: 700px;
    }
  }
}
</style>
